import { getUserAgent, getNavigator } from './device.js';

// Safari doesn't have iphone string in the userAgent
const isAppleDeviceSafari = () => {
    const userAgent = getUserAgent()?.toLowerCase();
    const navigatorObject = getNavigator();
    return (navigatorObject !== undefined &&
        navigatorObject.maxTouchPoints > 0 &&
        userAgent?.includes('safari') &&
        !userAgent?.includes('chrome'));
};
const checkIsAppleDevice = () => {
    const userAgent = getUserAgent();
    return (userAgent !== undefined &&
        !!(/macintosh|macintel|macppc|mac68k|macos|iphone|ipad|ipod/gm.test(userAgent.toLowerCase()) || isAppleDeviceSafari()));
};

export { checkIsAppleDevice };
//# sourceMappingURL=checkIsAppleDevice.js.map
